import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SaveButton from "../../components/button/SaveButton";
import { MainContainer } from "../../components/container/MainContainer";
import { useContextProvider } from "../../components/page-context/ContextProvider";
import SegmentedTabs from "../../components/tabs/SegmentedTabs";
import { Process } from "../../db_access/process";
import { ReusedProduct } from "../../db_access/reused_product";
import Footprint from "../../environment-page-components/Footprint";
import LifeCycleAssessment from "../../environment-page-components/LifeCycleAssessment";
import LifeCycleInventory from "../../environment-page-components/LifeCycleInventory";
import ReuseImpactSummary from "../../environment-page-components/ReuseImpactSummary";
import SankeyDiagram from "../../environment-page-components/SankeyDiagram";
import SystemBoundary from "../../environment-page-components/SystemBoundary";
import routing from "../../routing";
import "../../style/pages-style/Supplier.css";
import ReusedProductProductInfo from "./Reuse_Workspace/ReusedProduct_ProductInfo";
import ReusedProductScopeAndGoals from "./Reuse_Workspace/ReusedProduct_ScopeAndGoals";
import ReusedProductSupplierInfo from "./Reuse_Workspace/ReusedProduct_SupplierInfo";

const defaultReusedProduct = {
  id: null,
  assumptions: "",
  extended_service_life: 0,
  intro: "",
  isEpd: false,
  place_of_manufacture: "",
  place_of_use: "",
  service_life: 0,
  specifications: "",
  uniformat_II_1: null,
  uniformat_II_2: null,
  uuid: "",

  detail_address: "",
  detail_contact_person: "",
  detail_email: "",
  detail_phone: "",

  name: "",
  functional_unit: "",
  other_unit: "",
  scope: "",
  goals: "",
  system_boundary: "",
  epd_link: "",
  pcr_link: "",
};

function ProductReuseWorkspace() {
  const { selectedProducts, selectedProductIds, refresh } = useContextProvider();
  const navigate = useNavigate();
  const [processes, setProcesses] = useState([]);
  const [reusedProduct, setReusedProduct] = useState(defaultReusedProduct);

  const [activeSubTab, setActiveSubTab] = useState("Product Info");
  const product_info = { label: "Product Info", value: "Product Info" };
  const lca = { label: "Assessments", value: "Assessments" };
  const result = { label: "Results", value: "Results" };
  const subTabs = [product_info, lca, result];

  useEffect(() => {
    if (selectedProductIds && selectedProductIds.length > 0) {
      ReusedProduct.getByProductId(selectedProductIds[0])
        .then((res) => res.json())
        .then((data) => {
          const fetched = data[0] || defaultReusedProduct;
          const parentProduct = selectedProducts.find(p => p.id === selectedProductIds[0]);
          setReusedProduct({
            ...fetched,
            isEpd: parentProduct?.is_epd === 1 || fetched.isEpd === true
          });
        });
    }
  }, [selectedProductIds, selectedProducts, refresh]);

  useEffect(() => {
    if (selectedProducts.length === 0) {
      setProcesses([]);
      navigate(routing.sector.products.dashboard);
    } else {
      Process.get_by_product_ids(selectedProducts.map((i) => i.id))
        .then((res) => res.json())
        .then((dataVirgin) => {
          if (reusedProduct && reusedProduct.id) {
            Process.get_by_reused_product_id(reusedProduct.id)
              .then((res) => res.json())
              .then((dataReused) => {
                setProcesses([...dataVirgin, ...dataReused]);
              });
          } else {
            setProcesses(dataVirgin);
          }
        });
    }
  }, [selectedProducts, navigate, reusedProduct]);

  return (
    <MainContainer>
      <Box sx={{ display: selectedProducts.length === 1 ? "block" : "none" }}>
        {/* ── Workspace Page Heading & Action Bar (Combined) ─────────── */}
        <Box sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 3,
          gap: 3
        }}>
          {/* Segmented Tabs — left-aligned, full-width up to 800px */}
          <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-start" }}>
            <Box sx={{ width: "100%", maxWidth: "800px" }}>
              <SegmentedTabs
                options={subTabs}
                selected={activeSubTab}
                setSelected={setActiveSubTab}
                activeColor="#2196F3"
              />
            </Box>
          </Box>
        </Box>
        <Box sx={{ minHeight: "600px" }}>
          <Box sx={{ display: activeSubTab === product_info.value ? "flex" : "none", flexDirection: "column", gap: 3, animation: "org-fadeInUp 0.4s ease" }}>
            <ReusedProductProductInfo reusedProduct={reusedProduct} />
            <ReusedProductSupplierInfo reusedProduct={reusedProduct} />
          </Box>
          <Box sx={{ display: activeSubTab === lca.value ? "flex" : "none", flexDirection: "column", gap: 3, animation: "org-fadeInUp 0.4s ease" }}>
            <ReusedProductScopeAndGoals reusedProduct={reusedProduct} />
            <LifeCycleInventory title={"Reuse Life Cycle Inventory"} selectedID={selectedProducts[0]?.id} isSupplier={true} isReuse={true} reusedID={reusedProduct?.id} />
          </Box>
          <Box sx={{ display: activeSubTab === result.value ? "flex" : "none", flexDirection: "column", gap: 3, animation: "org-fadeInUp 0.4s ease" }}>
            <ReuseImpactSummary processes={processes} />
            <Box sx={{ display: reusedProduct?.isEpd !== true ? "flex" : "none", flexDirection: "column", gap: 3, minWidth: 0 }}>
              <Footprint processData={processes} pageType={"utilizer"} />
              <SankeyDiagram processData={processes} />
            </Box>
            <SystemBoundary processData={processes} isEpd={reusedProduct?.isEpd ? 1 : 0} />
            <LifeCycleAssessment selectedRow={reusedProduct} LCA_type={ReusedProduct.label} />
          </Box>
        </Box>
      </Box>
      <SaveButton />
    </MainContainer>
  );
}

export default ProductReuseWorkspace;
